import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AccessDenied from './AccessDenied';

const ProtectedRoute = ({ children, isAuthenticated, requiredRole, userRole }) => {
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredRole && userRole !== requiredRole) {
    return <AccessDenied />;
  }

  return children;
};

export default ProtectedRoute;
